import { Inline, Text, Button, Icon } from '@lightspeed/design-system-react'
import { T } from '@transifex/react'
import React from 'react'
import { useDispatch } from 'react-redux'
import {
  AddressErrorsStatus,
  AddressErrorStatusTypes,
} from '../../popover/hooks/useFulfillmentHelper'
import {
  openFulfilmentLineItemPopover,
  selectOpenFulfilmentPopoverLineItemId,
} from '../../../../../../state/slices/uiStateSlice'
import { useAppSelector } from '../../../../../../state/hooks'
import { HEAP_DATA_TRACK_ADD_ADDRESS } from '../../../../sale-model.constant'
import { FulfilmentDetail } from '../../../../../../models/fulfilment'
import {
  AddOrEditAddressButton,
  EditAddressButtons,
} from '../EditAddressButton'
import { useAddressModalHandlers } from '../hooks/useAddressModalHandlers'

interface AddressProps {
  isModalOpeningOnError?: boolean
  hasError: boolean
  addressStatus: AddressErrorStatusTypes
  lineItemLocalId?: string
  onSave?: (fulfillmentDetails: FulfilmentDetail[]) => void
}

export const EmptyAddressLegacy: React.FC<AddressProps> = ({
  isModalOpeningOnError,
  hasError,
  addressStatus,
  lineItemLocalId,
  onSave,
}: AddressProps) => {
  const buttonType =
    addressStatus === AddressErrorsStatus.EMPTYSHIPPING_EMPTYBILLING
      ? EditAddressButtons.add
      : EditAddressButtons.addShipping

  const isEmptyShippingNotEmptyBilling =
    addressStatus === AddressErrorsStatus.EMPTYSHIPPING_CORRECTBILLING ||
    addressStatus === AddressErrorsStatus.EMPTYSHIPPING_INCORRECTBILLING

  const { openAddressModal } = useAddressModalHandlers({
    type: buttonType,
    onSave,
  })

  const dispatch = useDispatch()
  const currentOpenLineItemId = useAppSelector(
    selectOpenFulfilmentPopoverLineItemId
  )
  const openFulfillmentPopover = () => {
    const targetLineItemId = lineItemLocalId || currentOpenLineItemId
    if (targetLineItemId) {
      dispatch(openFulfilmentLineItemPopover(targetLineItemId))
    }
  }

  return (
    <>
      <Text type="label">
        <T _str="Shipping & billing address" _context="Section title" />
      </Text>
      <Inline space={0}>
        {isEmptyShippingNotEmptyBilling ? (
          <>
            <Button
              modifier="text"
              variant="supplementary"
              onClick={openFulfillmentPopover}
              data-track={HEAP_DATA_TRACK_ADD_ADDRESS}
            >
              <Icon icon="plus" />
              <T _str="Add address" _context="Action link" className="vd-ml1" />
            </Button>
          </>
        ) : (
          <AddOrEditAddressButton
            type={buttonType}
            isModalOpeningOnError={isModalOpeningOnError}
            hasError={hasError}
            lineItemLocalId={lineItemLocalId}
            onSave={onSave}
            onOpenModal={openAddressModal}
          />
        )}
      </Inline>
    </>
  )
}
